/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NotificationConfigurationModel {
    getFixupPrototypeFunction() { return NotificationConfigurationModel.fixupPrototype; }

    static newInstance(model: Partial<NotificationConfigurationModel>): NotificationConfigurationModel {
        let obj = Object.assign(new NotificationConfigurationModel(), model);
        NotificationConfigurationModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NotificationConfigurationModel>): NotificationConfigurationModel {
        if (!model) return null;
        return NotificationConfigurationModel.newInstance(<NotificationConfigurationModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NotificationConfigurationModel) {
        if (!obj) return;

        models.NotificationConfigurationModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NotificationConfigurationModel): boolean {
        Object.setPrototypeOf(obj, NotificationConfigurationModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.notification_details) {
            for (let val of this.notification_details) {
                models.NotificationDetailsModel.fixupPrototype(val);
            }
        }
    }

    /**
     * notification name
     */
    name: string;

    /**
     * Notification Details
     */
    notification_details: Array<models.NotificationDetailsModel>;

}
